module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "direct-message-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-flex', {
    staticClass: "dismiss-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "popup-section",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "content-section",
    class: {
      sm7: _vm.$store.state.auth.user.user_type == 'artist',
      sm12: _vm.$store.state.auth.user.user_type != 'artist',
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "avatar-image",
    style: ({
      'background-image': 'url(' + _vm.receiver.avatar.thumb.url + ')',
    })
  }), _vm._v(" "), _c('p', {
    staticClass: "user-name"
  }, [_vm._v("\n        " + _vm._s(_vm.receiver.username) + "\n        "), (_vm.receiver.user_type == 'artist') ? _c('v-icon', {
    staticClass: "user-status",
    class: {
      online: _vm.receiver.status == 'active'
    }
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1), _vm._v(" "), (_vm.$store.state.auth.user.user_type == 'artist') ? _c('label', {
    staticClass: "repost-price"
  }, [_vm._v("Repost Price: $" + _vm._s(_vm._f("formatNumber")(_vm.receiver.repost_price)))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "send-message-section relative"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.message),
      expression: "message",
      modifiers: {
        "trim": true
      }
    }],
    ref: "message",
    staticClass: "message-input-area",
    attrs: {
      "maxlength": "500",
      "placeholder": "Write a message..."
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.showEmojiPicker) ? _c('picker', {
    staticClass: "emoji-picker",
    attrs: {
      "title": "Pick your emoji…",
      "emoji": "point_up"
    },
    on: {
      "click": _vm.addEmoji
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "show-emoji-box-btn",
    class: {
      selected: _vm.showEmojiPicker
    },
    nativeOn: {
      "click": function($event) {
        _vm.showEmojiPicker = !_vm.showEmojiPicker
      }
    }
  }, [_c('v-icon', [_vm._v("tag_faces")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "send-message-btn",
    attrs: {
      "disabled": !_vm.message
    },
    nativeOn: {
      "click": function($event) {
        _vm.checkMessage()
      }
    }
  }, [_vm._v("Send")])], 1)]), _vm._v(" "), (_vm.$store.state.auth.user.user_type == 'artist') ? _c('v-flex', {
    staticClass: "requests-section",
    class: {
      sm5: _vm.$store.state.auth.user.user_type == 'artist',
      sm12: _vm.$store.state.auth.user.user_type != 'artist',
    },
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "header-section"
  }, [_c('p', {
    staticClass: "section-title"
  }, [_vm._v("Request repost")]), _vm._v(" "), _c('div', {
    staticClass: "option-area"
  }, [_c('v-btn', {
    staticClass: "request-option-btn",
    class: {
      selected: _vm.tab == 'album'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onTab('album')
      }
    }
  }, [_vm._v("Album")]), _vm._v(" "), _c('v-btn', {
    staticClass: "request-option-btn",
    class: {
      selected: _vm.tab == 'merch'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onTab('merch')
      }
    }
  }, [_vm._v("Product")])], 1)]), _vm._v(" "), (_vm.tab == 'album') ? _c('div', {
    staticClass: "content-section"
  }, _vm._l((_vm.albums), function(album) {
    return _c('div', {
      key: album.id,
      staticClass: "request-item",
      class: {
        selected: _vm.item == album,
        banned: _vm.InBanned(album)
      },
      on: {
        "click": function($event) {
          _vm.InBanned(album) ? null : _vm.selectItem(album)
        }
      }
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('div', {
      staticClass: "avatar-image",
      style: (("background-image: url(" + (album.cover.thumb.url) + ")"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [_c('label', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(album.name))]), _vm._v(" "), _c('label', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(album.user.username))])])])
  })) : _vm._e(), _vm._v(" "), (_vm.tab == 'merch') ? _c('div', {
    staticClass: "content-section"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      key: product.id,
      staticClass: "request-item",
      class: {
        selected: _vm.item == product,
        banned: _vm.InReposted(product)
      },
      on: {
        "click": function($event) {
          _vm.InReposted(product) ? null : _vm.selectItem(product)
        }
      }
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('div', {
      staticClass: "avatar-image",
      style: (("background-image: url(" + (product.covers[0].cover.thumb.url) + ")"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [_c('label', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('label', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(product.merchant.username))])])])
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.show_repost_payment_modal) ? _c('repost-payment-modal', {
    attrs: {
      "item": _vm.item,
      "itemType": _vm.tab,
      "receiver": _vm.receiver,
      "dismiss": _vm.closeRepostPaymentModal,
      "finish": _vm.sendMessage
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-123d51a0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sendmessage.vue
// module id = 1614
// module chunks = 180